<div style="position: relative; display: inline-block; width: 100%;">
	<triv-input [data]="data" [fGroup]="fGroup"></triv-input>
	<mat-icon *ngIf="hasValue"
		style="cursor:pointer; position: absolute; right: 10px; top: 37%; transform: translateY(-50%); color: #43483e;" 
		(click)="togglePasswordVisibility()">
		{{ showPassword ? 'visibility_off' : 'visibility' }}
	</mat-icon>
</div>
